import type { RegionalUser, User } from '../user/user.interface'

export type UserDisplayData = {
  fullName: string
  email: string
}

type RegionalUserNameFields = Pick<RegionalUser, 'firstname' | 'lastname'>

export function formatRegionalUserDisplayName(regionalUser: RegionalUserNameFields | null | undefined): string {
  if (!regionalUser) {
    return ''
  }

  return [regionalUser.firstname, regionalUser.lastname].filter(Boolean).join(' ')
}

export function getUserDisplayData(user: User | null | undefined): UserDisplayData {
  const profileName = user?.profile?.name || user?.profile?.nickname || ''
  const fullName = formatRegionalUserDisplayName(user?.regionalData ?? undefined) || profileName || 'User'

  const email = user?.regionalData?.userEmail || user?.profile?.email || ''

  return {
    fullName,
    email,
  }
}
